export const MESSAGES_TAB = '@@subtabs/MESSAGES_TAB';
export const MYSELF_TAB = '@@subtabs/MYSELF_TAB';
export const STORYLET_TAB = '@@subtabs/STORYLET_TAB';